module.exports = __webpack_public_path__ + "static/media/pay_pep.fa3885ac.svg";